module.exports = __webpack_public_path__ + "static/media/change-banner.178e2886.svg";